import _ from '@/utils/lodash-optimized'
import { Component, createRef } from 'react'

import { PlainButton } from '../../../../../shared/Button'
import {
  bindTargetMixin,
  CheckboxInput,
  Icd10AutocompleteInput,
  SaveButton,
  TextInput
} from '../../../../../shared/FormBuilder'
import { Paper } from '../../../../../shared/NarusMaterial'
import { narusGrey5 } from '../../../../../shared/NarusMaterial/colors'

class DiagnosisForm extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)
    this.diagnosisRef = createRef()
  }

  forDisplay = (list, attr = 'label') =>
    _.sortBy(
      _.map(list, a =>
        _.merge(a, { label: _.startCase(a[attr].toLowerCase()) })),
      a => a.label.toLowerCase()
    )

  getValue = () => ({ ...this.state.value })

  handleSubmit = () => {
    const { onSubmit } = this.props
    this.setState({ isSubmitting: true })
    onSubmit(this.getValue())
  }

  renderDiagnosis () {
    const style = {
      textField: {
        marginBottom: '1rem',
        width: '100%'
      },
      buttonMargin: {
        marginTop: '1rem'
      },
      radioButton: {
        display: 'inline-block',
        width: '5rem'
      },
      radioGroup: {
        display: 'inline-block',
        verticalAlign: 'middle'
      },
      subHead: {
        color: `${narusGrey5}`
      },
      saveButton: {
        marginLeft: '1rem'
      },
      marg: {
        marginTop: '1rem'
      }
    }

    const disableSave = !this.state.value.name

    return (

      <form
        onKeyDown={this.props.onKeyDown}
        className='margin-top margin-bottom'
      >
        <Paper>
          <div className='row'>
            <div className='col-xs-12'>
              <div className='row'>
                <input
                  type='hidden'
                  name='id'
                />
                <div className='col-xs-12 col-md-12'>
                  <Icd10AutocompleteInput
                    name='name'
                    ref={this.diagnosisRef}
                    required
                    onChange={value => {
                      if (!value) {
                        return
                      }

                      let { chapter, category, severity } = value

                      this.setInputValue('chapter', chapter ?? '')
                      this.setInputValue('category', category ?? '')
                      this.setInputValue('severity', severity?.toString(10) ?? '1')
                      this.setInputValue('admitting', (severity ?? 1) >= 3)
                    }}
                  />
                </div>
              </div>

              <div className='row middle-xs'>
                <div
                  className='col-xs-12 col-sm-7 col-md-8'
                  style={{ alignSelf: 'baseline' }}
                >
                  <TextInput
                    label='Chapter'
                    name='chapter'
                    disabled
                  />
                </div>

                <div
                  className='col-xs-12 col-sm-5 col-md-4'
                  style={{ alignSelf: 'baseline' }}
                >
                  <TextInput
                    label='Category'
                    name='category'
                    disabled
                  />
                </div>
              </div>

              <div className='row middle-xs'>
                <div
                  className='col-xs-12 col-sm-7 col-md-8'
                  style={{ alignSelf: 'baseline' }}
                >
                  <TextInput
                    label='Treating Physician'
                    name='treatingPhysician'
                  />
                </div>

                <div
                  className='col-xs-12 col-sm-5 col-md-4'
                  style={{ alignSelf: 'baseline' }}
                >
                  <CheckboxInput
                    label='Qualifying Diagnosis'
                    name='admitting'
                  />
                </div>
              </div>

              <div className='row'>
                <div className='col-md-6'>
                  <TextInput
                    label='Severity'
                    name='severity'
                  />
                </div>
                <div className='col-md-6'>
                  <TextInput
                    label='Comment'
                    name='comment'
                  />
                </div>
              </div>

              <div className='row'>
                <div className='col-md-6'>
                  <TextInput
                    label='Onset Month'
                    name='onsetMonth'
                  />
                </div>
                <div className='col-md-6'>
                  <TextInput
                    label='Onset Year'
                    name='onsetYear'
                  />
                </div>
              </div>

              <div className='row'>
                <div className='col-xs-12'>
                  <TextInput
                    label='Onset Comment'
                    name='onsetComment'
                  />
                </div>
              </div>
            </div>
            <div className='row'>
              <div
                className='col-xs-12 col-md-12'
                style={{ alignSelf: 'baseline' }}
              >
                <CheckboxInput
                  label='Discussed with Patient'
                  name='discussedWithPatient'
                />
              </div>
            </div>
          </div>

          <div
            className='row end-xs margin-top'
            style={style.marg}
          >
            <div className='button-container'>
              <PlainButton
                label='Cancel'
                onClick={this.props.onCancel}
              />
              <SaveButton
                disabled={disableSave || this.state.isSubmitting}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </Paper>
      </form>
    )
  }

  render () {
    return <div>{this.renderDiagnosis()}</div>
  }
}

export default DiagnosisForm
